import Vuex from "vuex";
import { fetchHil } from "../utils";

export default {
  namespaced: true,
  state: {
    kbitems: []
  },
  mutations: {
    setKbItems(state, kbitems) {
      state.kbitems = kbitems;
    }
  },
  actions: {
    async fetchKbItems({ commit }) {
      const resp = await (await fetchHil(`/kbitems`)).json();
      commit("setKbItems", resp);
    }
  }
}
